import React from  'react';
import ReactDOM from 'react-dom';
import App from './App';
import App_Movil from './App_Movil';

//import 'bootstrap/dist/css/bootstrap.css'


const container = document.getElementById('root')

/** Oculta el SplashScreen estático de index.html apenas React termina de pintar la primera pantalla. */
function ocultarSplashScreen() {
  const splash = document.getElementById('splash-screen')
  if (!splash) return

  splash.classList.add('splash-screen--hidden')
  splash.addEventListener('transitionend', () => splash.remove(), { once: true })
}

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    ReactDOM.render(<App_Movil/>,container, ocultarSplashScreen)
}else{

    ReactDOM.render(<App/>,container, ocultarSplashScreen)

}


